module.exports = __webpack_public_path__ + "img/08-install-step-3-find-apk.56a9307c.webp";